import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { NavigationDotVerticalOutlineIcon } from '@compono/ui-icons';
import { MenuIconButton } from '../Menu/MenuIconButton/MenuIconButton.js';

var TableActionButton = function TableActionButton(_a) {
    var _b = _a.look, look = _b === void 0 ? "tertiary" : _b, _c = _a.size, size = _c === void 0 ? "sm" : _c, _d = _a.tone, tone = _d === void 0 ? "primary" : _d, _e = _a.rounded, rounded = _e === void 0 ? false : _e, children = _a.children, props = __rest(_a, ["look", "size", "tone", "rounded", "children"]);
    return (jsx(MenuIconButton, __assign({ type: "button" }, __assign({ label: "Actions", look: look, size: size, tone: tone, rounded: rounded }, props), { children: children ? children : jsx(NavigationDotVerticalOutlineIcon, {}) })));
};

export { TableActionButton };
//# sourceMappingURL=TableActionButton.js.map
